import AmexFlipComponent from './AmexFlipComponent';

export default AmexFlipComponent;
